import React, { useEffect, useState, useContext, useRef } from 'react';
import Layout from './layout';
import api from '../../services/api';
import {useParams, useHistory, useLocation} from 'react-router';
import {toast} from 'react-toastify';
import Modal from '../../components/Modal';
import AppContext from '../../redux/contexts/appContext';
import Socket from '../../services/socket';

function Room() {
  const {roomid} = useParams();
  const history = useHistory();
  const location = useLocation();
  const [room, setRoom] = useState(null);
  const [loading, setLoading] = useState(false);
  const [, updateState] = React.useState();
  const forceUpdate = React.useCallback(() => updateState({}), []);
  const [selectedSubPageState, _setSelectedSubPage] = useState("About");
  const selectedSubPageStateRef = useRef(selectedSubPageState);
  const [alertModal, setAlertModal] = useState(null);

  const {state, dispatch} = useContext(AppContext);
  var interval = null;
  
  const setUpSocket = () => {
    if (!room) {
      return false;
    }
    if (Socket.GetConnection() === null) {
      Socket.Connect();
    }
    Socket.LeaveRoom({});
    Socket.JoinRoom({id: state.user.id, value: state.user.name, roomId: roomid});
    
    let lastInterval = sessionStorage.getItem("pi");
    
    if (lastInterval) {
      clearInterval(lastInterval);
    }
    interval = setInterval(() => {
      Socket.Ping({});
    }, 10000)
    sessionStorage.setItem("pi", interval.toString());
    socketListeners();
  }

  const setSelectedSubPage = (value) => {
    _setSelectedSubPage(value);
    selectedSubPageStateRef.current = value;

  }

  const socketListeners = () => {
    const connection = Socket.GetConnection();
    connection.removeAllListeners();

    // Receive member
    connection.on('ReceiveMember', payload => {
      var tempRoom = room;
      if (!tempRoom) return false;
      var foundUser = tempRoom.members.find(m => m.id == payload.id);
      if (!foundUser) {
        tempRoom.members.push({
          id: payload.id,
          name: payload.value,
          char: payload.char,
          voted: payload.voted
        });
        setRoom(tempRoom);
        forceUpdate();
      }
    });

    connection.on("RemoveMember", payload => {
      var tempRoom = room;

      if (payload.id === state.user.id) {
        toast.warn("You were removed from the room")
        return history.push('/')
      }
      
      tempRoom.members = tempRoom.members.filter(m => m.id !== payload.id);
      //setRoom(tempRoom);
      forceUpdate();
    });

    connection.on('ReceiveVote', payload => {
      var tempRoom = room;

      
      if (payload.value !== null) {
        tempRoom.votes = tempRoom.votes.filter(m => m.userid !== payload.id);
        let lastUserVoteIndex = tempRoom.votes.findIndex(v => v.userid == payload.id);
        if (lastUserVoteIndex === -1) {
          tempRoom.votes.push(payload.value);
        }
        else {
          tempRoom.votes[lastUserVoteIndex] = payload.value
        }
      }
      
      var tempMember = tempRoom.members.find(m => m.id == payload.id);
      tempRoom.members = tempRoom.members.filter(m => m.id !== payload.id);
      tempMember.voted = true;

      tempRoom.members.push(tempMember);

      setRoom(tempRoom);
      forceUpdate();
    })

    connection.on('ReceiveVotes', payload => {

      if (!payload.votes) return false;
      var tempRoom = room;

      // Alerts --------------------------------------
      // If the user vote has been removed => alert him

      // If the show votes change => Alert user
      if (payload.showVotes && !tempRoom.showVotes) {
        var me = payload.votes.find(m => m.userid === state.user.id);
        if (me|| tempRoom.creatorId === state.user.id) {
          changeSubPage("Results"); // Go ro results sub page
        }
        toast.success("Admin released the votes")
      } else if (!payload.showVotes && tempRoom.showVotes && payload.votes.length === 0) { // If the vote status resets => alert user
        toast.warn("All the votes were reset");

        if (selectedSubPageStateRef.current === "Results") {
          if (tempRoom.creatorId !== state.user.id) {
            setSelectedSubPage("Vote");
          } else {
            setSelectedSubPage("About");
          }
        }
        
      }


      tempRoom.votes = payload.votes;
      if (payload.members) {
        tempRoom.members = payload.members;
      }
      tempRoom.showVotes = payload.showVotes;
      setRoom(tempRoom);
      forceUpdate();
    })

    connection.on("RemovedVoteByAdmin", payload => {
      if (payload.userid == state.user.id) {
        toast.warn("Your vote was removed by the room admin")
      }
    })

    connection.on('DeleteRoom', payload => {
      if (location.pathname === "/room/"+roomid) {
        if (room.creatorId !== state.user.id) {
          toast.warn("The room was deleted by the room admin")
        }
        history.push('/');
      }
    })
  }

  const onVote = (value, coffee = false) => {
    setLoading(true);
    api().post(`/room/${room.roomCode}/member/${state.user.id}/vote`, {value, coffee})
    .then(response => {
      setLoading(false);
    })
    .catch(err => {
      setLoading(false);
    })
  }

  const onShowVotes = () => {
    setLoading(true);
    api().post(`/room/${room._id}/show-votes`)
    .then(response => {
      setLoading(false);
    })
    .catch(err => {
      setLoading(false);
    })
  }

  const onResetVotes = () => {
    setLoading(true);
    api().post(`/room/${room._id}/reset-votes`)
    .then(response => {
      setLoading(false);
    })
    .catch(err => {
      setLoading(false);
    })
  }

  const onRevert = (memberId) => {
    setLoading(true);
    api().post(`/room/${room.roomCode}/member/${memberId}/reset-vote`)
    .then(response => {
      setLoading(false);
    })
    .catch(err => {
      setLoading(false);
    })
  }

  const onBan = (memberId) => {
    setLoading(true);
    api().delete(`/room/${room.roomCode}/member/${memberId}/ban`)
    .then(response => {
      setLoading(false);
    })
    .catch(err => {
      setLoading(false);
    })
  }

  const onRemove = (memberId) => {
    setLoading(true);
    api().delete(`/room/${room.roomCode}/member/${memberId}/remove`)
    .then(response => {
      setLoading(false);
    })
    .catch(err => {
      setLoading(false);
    })
  }
  const loadRoomData = () => {
      
    setLoading(true);
    api().get('/room/'+roomid)
    .then(response => {
      setLoading(false);
      var room = response.data.result;
      
      if (!state || !state.user || !state.user.id) return history.push('/');

      var userid = state.user.id;
      var found = room.members.find(m => m.id === userid); 

      if (room.creatorId !== userid && !found) {
        return history.push('/')
      }

      setRoom(room);
    })
    .catch(err => {
      setLoading(false);
      history.push('/');
    })
  }

  const loadAndSetUpSocket = () => {
    loadRoomData();
    setUpSocket();

  }

  const removeEventListeners = () => {
    clearInterval(interval);
    window.removeEventListener("focus", loadAndSetUpSocket);
    let lastInterval = sessionStorage.getItem("pi");
    if (lastInterval) {
      clearInterval(lastInterval);
    }
  }

  useEffect(() => {
    var unlisten = history.listen((e) => {
      var connection = Socket.GetConnection();
      if (connection) {
        connection.removeAllListeners();
      }
      unlisten();
    })

    loadRoomData();

    window.addEventListener("focus", loadAndSetUpSocket);
    return () => {
      removeEventListeners();
    }
  }, [])




  useEffect(() => {
    setUpSocket();
  }, [room])


  const onExit = () => {

    setLoading(true);
    api().delete(`/room/${room.roomCode}/member/${state.user.id}/remove`)
    .then(res => {
      setLoading(false);
      history.push('/')
      //if (onRoomRemove) onRoomRemove(room._id);
    })
    .catch(err => {
      setLoading(false);
      if (err?.response?.data?.msg) {
        setAlertModal(err.response.data.msg);
      }
      else {
        setAlertModal("Internal Server Error");
      }
    })
  }

  const changeSubPage = (to) => {
    setSelectedSubPage(to);
  }


  useEffect(() => {
  }, [selectedSubPageState])

  const onDelete = () => {

    setLoading(true);
    api().delete(`/room/${room._id}`)
    .then(res => {
      setLoading(false);
      //if (onRoomRemove) onRoomRemove(room._id);
    })
    .catch(err => {
      setLoading(false);
      if (err?.response?.data?.msg) {
        setAlertModal(err.response.data.msg);
      }
      else {
        setAlertModal("Internal Server Error");
      }
    })
  }
  
  return (
  <>
    <Layout onRevert={onRevert} selectedSubPageState={selectedSubPageState} changeSubPage={changeSubPage} onBan={onBan} onRemove={onRemove} onResetVotes={onResetVotes} showVotes={room?.showVotes} onShowVotes={onShowVotes} onDelete={onDelete} onExit={onExit} loading={loading} room={room} forceUpdate={forceUpdate} onVote={onVote}/>
    <Modal visible={alertModal !== null} title={"Alert"} onCancel={() => setAlertModal(null)} onSubmit={() => setAlertModal(null)} cancelText={false} >
        {alertModal}
    </Modal>
  </>
  )
}

export default Room;